import styled, { ThemeProvider } from 'styled-components';
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import Routes from './routes';
import { HydrateDummyView } from '@AIZ-GL/hydrate-dummy';

import coordinateExperiments from './experiments';
import initializeModernizr from './utils/initialize-modernizr';

import configureStore from './config/configure-store';

import theme from './config/theme';
import './design/icons.css';

export default class Root extends Component {
  componentDidMount() {
    coordinateExperiments();
    initializeModernizr();
  }

  renderHydrateDummy() {
    if (!this.props.debug) {
      return null;
    }

    return <HydrateDummyView />;
  }

  render() {
    const { store, history } = configureStore({});

    return (
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <Container>
            <HistoryRouter history={history}>
              <Routes />
              {this.renderHydrateDummy()}
            </HistoryRouter>
          </Container>
        </Provider>
      </ThemeProvider>
    );
  }
}

const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
`;
